<template>
  <div v-if="userHasAccess" id="show-book">
    <!--Sticy Top Nav for Show book Page -->
    <div class="sticky top-0 z-20">
      <div v-if="testMode" class="flex space-x-2 items-center justify-center py-4 bg-blue-600 text-center sticky top-0">
        <p class=" text-lg text-white mb-0.5">You are currently in test mode for the show books tool.</p>
        <button class="text-sm text-white py-1.5 px-2 border rounded-md hover:bg-white hover:text-blue-600 hover:font-medium" @click="testModeChange">Leave Test Mode</button>
      </div>
      <div class="flex flex-col md:flex-row justify-between  bg-white py-1 sm:py-2 shadow">
        <nav class="flex px-1 sm:px-2" aria-label="Breadcrumb">
          <ol role="list" class="flex items-center space-x-1 sm:space-x-2">
            <li>
              <div>
                <button class="text-xs sm:text-sm font-medium text-gray-600 hover:text-gray-800">
                  Show Books
                </button>
              </div>
            </li>
            <li v-if="show_book">
              <div class="flex items-center">
                <svg class="h-4 sm:h-5 w-4 sm:w-5 flex-shrink-0 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd" />
                </svg>
                <button @click="navClicked('show')" class="ml-1 sm:ml-3 text-xs sm:text-sm font-medium text-gray-600 hover:text-gray-800">{{show_book.name}}</button>
              </div>
            </li>
            <li v-if="selectedDivision.name && division_list.length > 1">
              <div class="flex items-center">
                <svg class="h-4 sm:h-5 w-4 sm:w-5 flex-shrink-0 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd" />
                </svg>
                <button @click="navClicked('division')" class="ml-1 sm:ml-3 text-xs sm:text-sm font-medium text-gray-600 hover:text-gray-800">{{selectedDivision.name}}</button>
              </div>
            </li>

            <li v-if="selectedClass && class_list.length > 1">
              <div class="flex items-center">
                <svg class="h-4 sm:h-5 w-4 sm:w-5 flex-shrink-0 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd" />
                </svg>
                <button @click="navClicked('class')" class="ml-1 sm:ml-3 text-xs sm:text-sm font-medium text-gray-600 hover:text-gray-800" aria-current="page">{{selectedClass}}</button>
              </div>
            </li>
          </ol>
        </nav>
        <div v-if="showBookLoaded" class="flex flex-wrap justify-end items-center pt-1 md:pt-0 mt-0.5 md:mt-0 border-t md:border-none">
          <div id="manual_entry_toggle" v-if="arrangeEntries" class="mr-3">
            <button type="button" @click="arrangeEntries = false" class="inline-flex items-center rounded-md border border-transparent border-red-600 px-4 py-2 text-sm font-medium text-red-700 hover:bg-red-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-1 ">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
              Turn Off Move Entries Manually</button>
          </div>
          <button class="text-base font-semibold mr-3 inline-flex items-center rounded-md border border-transparent bg-green-500 px-3 py-1.5 text-base font-medium leading-4 text-white shadow-sm hover:text-green-100 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2" @click="saveShowBook">Save Show Book</button>
          <label v-if="!testMode" class="mt-1 block text-gray-800 font-lg font-bold flex items-center" v-tooltip="'Make Public - Viewable from the show schedule'">
            <input v-model="show_book_published" class="mr-1 leading-tight" type="checkbox" @change="showBookPublishedUpdate">
            <span class="text-sm">
              Published
            </span>
          </label>
          <a :href="`/print?show_id=${show_book.show_id}&ring_id=${encodeURIComponent(selectedRing)}&type=${printShowType}&name=${encodeURIComponent(show_book.name)}&list_type=Ring List&start_date=${adminData.event.start_date}&use_dynamic=${adminData.event.event_settings.dynamic_class_lists}&testMode=${testMode}&eventName=${encodeURIComponent(adminData.event.name)}`" target="_blank" class="inline-flex items-center rounded-md border border-transparent px-2 py-1 text-sm font-medium leading-4 text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 mr-1">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z" />
            </svg>
            Print
          </a>
          <dropdown-button ref="dropdownButton">
            <span slot="link" class="inline-flex items-center rounded-md border border-transparent px-2 py-1 text-sm font-medium leading-4 text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
              </svg>
            </span>
            <div slot="dropdown" class="w-64 bg-white border shadow rounded-md overflow-hidden text-center divide-y divide-gray-200 text-sm">
              <div class="py-1" role="none">
                <update-show-order v-if="!testMode" :classList="show_book.show_book" v-tooltip="'Change the order of the divisions.'" @updateClassList="divisionOrderUpdated" :displayType="'dropdown-item'"/>
                <button class="text-gray-900 group flex w-full items-center px-2 py-2 text-gray-800 hover:bg-gray-200" v-tooltip="'Move individual entries between classes'" @click="arrangeEntries = !arrangeEntries; $refs.dropdownButton.close()">
                  <template v-if="!arrangeEntries">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 w-5 h-5">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5" />
                    </svg>
                    Move Entries Manually
                  </template>
                  <template v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 mr-3 text-red-700">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    Turn Off Move Entries Manually
                  </template>
                </button>
                <ConfigureShowRings  v-if="!testMode" v-tooltip="'Split divisions into separate rings.'" :displayType="'dropdown-item'" @ringUpdate="ringConfigUpdated" :show_book="show_book"/>
                <a class="text-gray-900 group flex w-full items-center px-2 py-2 text-gray-800 hover:bg-gray-200" :href="`/print?show_id=${show_book.show_id}&ring_id=${encodeURIComponent(selectedRing)}&type=${printShowType}&name=${encodeURIComponent(show_book.name)}&list_type=Ring List&preview=true&start_date=${adminData.event.start_date}&use_dynamic=${adminData.event.event_settings.dynamic_class_lists}&eventName=${encodeURIComponent(adminData.event.name)}`" target="_blank">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Preview Show Book
                </a>
                <button class="text-gray-900 group flex w-full items-center px-2 py-2 text-gray-800 hover:bg-gray-200" @click="testModeChange">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" data-slot="icon" class="mr-3 w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                  </svg>
                  <template v-if="testMode">
                    Exit Test Mode
                  </template>
                  <template v-else>
                    Enter Test Mode
                  </template>
                </button>
              </div>
              <div class="py-1" role="none">
                <button class="text-gray-900 group flex w-full items-center px-2 py-2 text-xs text-gray-800 hover:text-white hover:bg-red-500" @click="regenShowBook">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 h-5 w-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                  </svg>
                  Regenerate Show Book
                </button>
              </div>
            </div>
          </dropdown-button>
        </div>
      </div>
    </div>

    <div v-if="!show_book">
      <div class="px-2 md:px-0 mx-auto max-w-lg mt-8">
        <div class="text-center">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mx-auto h-12 w-12 text-gray-500">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
          </svg>
          <h2 class="mt-2 text-lg font-medium text-gray-900">Select a show book</h2>
          <p class="mt-1 text-sm text-gray-600">Choose the show book you would like to work with.</p>
        </div>
        <div class="mt-6">
          <multiselect  @input="getShowBook"  v-model="show_book" :options="adminData.show_books" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Select a show" label="name" :preselect-first="false" :custom-label="(option) => {return option.name}" :hideSelected="true">
            <div slot="singleLabel" slot-scope="{ option }" class="text-lg font-">
              {{option.name}}
            </div>
          </multiselect>
        </div>
      </div>
    </div>
    <div v-else-if="showBookLoading" class="pt-12">
      <vue-simple-spinner size="huge" message="Loading Show Book" line-fg-color="orange"/>
    </div>
    <div v-else-if="showBookLoaded" ref="top" class=" " >
      <div class="bg-gray-200 px-2 sm:px-4 py-2 sm:py-4 border-b flex flex-col space-y-3">
        <div class="flex flex-col sm:flex-row justify-between items-center sm:space-x-3 space-y-2 sm:space-y-0">
          <div class="w-full md:w-1/2 flex-shrink-0">
            <label for="location" class="block text-lg font-medium text-gray-700 mb-1">Show Book ({{totalEntries}} Entries)</label>
            <multiselect ref="show_dropdown" @input="getShowBook"  v-model="show_book" :options="adminData.show_books" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Select a show" label="name" :preselect-first="false" :custom-label="(option) => {return option.name}" :hideSelected="true">
              <div slot="singleLabel" slot-scope="{ option }" class="text-lg font-">
                {{option.name}}
              </div>
            </multiselect>
          </div>
          <div v-if="ring_list.length > 1" class="w-full">
            <label for="location" class="block text-lg font-medium text-gray-700 mb-1">Ring</label>
            <multiselect ref="ring_dropdwon" @input="getShowBook"  v-model="selectedRing" :options="ring_list" :multiple="false" :close-on-select="true" :clear-on-select="true" :preserve-search="true" placeholder="Select a show" label="name" :preselect-first="false" :custom-label="(option) => {return option}" :hideSelected="false">
              <div slot="singleLabel" slot-scope="{ option }" class="text-lg font-">
                {{option}}
              </div>
            </multiselect>
          </div>
        </div>
        <hr/>
        <div class="flex flex-row justify-start items-end sm:space-x-3 space-y-2 sm:space-y-0">
          <div class="w-full md:w-1/2">
            <div>
              <label for="division" class="block text-lg font-medium text-gray-700">
                Division
                <span class='text-xs font-semibold text-gray-800'>(Use dropdown to change division)</span>
              </label>
              <multiselect ref="division_dropdown" v-model="selectedDivision" @select="updateSelectedDivision" :options="division_list" :close-on-select="true" :searchable="false" :allowEmpty="false" placeholder="Select a Division" :custom-label="(option) => {return `(${option.count}) ${option.name}`}"></multiselect>
            </div>
          </div>
          <div id="division-toolbar" v-if="class_list.length === 1" class="flex flex-col sm:flex-row justify-end items-center">
            <div class="w-full md:w-auto my-1 md:my-0" >
              <dropdown-button v-if="currentClassBreaks.length > 1" ref="sortButton" v-tooltip="'Change the order of the division (Click to see options)'">
                <span slot="link" class="inline-flex items-center rounded-md border border-transparent px-2 py-1 text-sm font-medium leading-4 text-gray-700 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-1 w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5" />
                </svg>
                  Sort Division
                </span>
                <div slot="dropdown" class="w-56 bg-white border shadow rounded-md overflow-hidden divide-y divide-gray-200 text-sm ">
                  <div class="py-1" role="none">
                    <a href="#" class="text-gray-900 group flex flex-col w-full px-2 py-2 text-gray-800 hover:bg-gray-200" @click="sortClass('ASC')">
                      <p class="text-base">Ascending</p>
                      <p class="text-sm">
                        <span v-if="currentClassSortField === 'date_of_birth'">
                          Order youngest to oldest
                        </span>
                        <span v-else>
                          Order lightest to heaviest
                        </span>
                      </p>
                    </a>
                    <a href="#" class="text-gray-900 group flex flex-col w-full px-2 py-2 text-gray-800 hover:bg-gray-200" @click="sortClass('DESC')">
                      <p class="text-base">Descending</p>
                      <p class="text-sm">
                        <span v-if="currentClassSortField === 'date_of_birth'">
                          Order oldest to youngest
                        </span>
                        <span v-else>
                          Order heaviest to lightest
                        </span>
                      </p>
                    </a>
                    <a href="#" class="text-gray-900 group flex w-full flex-col px-2 py-2 text-gray-800 hover:bg-gray-200" @click="sortClass('RANDOM')">
                      <p class="text-base">Random</p>
                      <p class='text-sm'>
                        Shuffle entries randomly
                      </p>
                    </a>
                  </div>
                  <div class="text-left p-2 text-xs">
                    <p class="">WARNING - Sorting entries will reset class breaks</p>
                  </div>
                </div>
              </dropdown-button>
            </div>
          </div>
        </div>
        <hr v-if="class_list.length > 1"/>
        <div v-if="class_list.length > 1" class="flex flex-row justify-start items-end sm:space-x-3 space-y-2 sm:space-y-0">
          <div  class="w-full md:w-1/2">
            <label for="location" class="block text-lg font-medium text-gray-700">Class</label>
            <multiselect ref="class_dropdown" v-model="selectedClass" @select="setClass" :options="class_list" :close-on-select="true" :searchable="false" :allowEmpty="false" placeholder="Select a Class" :custom-label="(option) => {return `(${getClassCount(option)}) ${option}`}"></multiselect>
          </div>
          <div id="toolbar" class="flex flex-col sm:flex-row justify-end items-center">
            <div class="w-full md:w-auto my-1 md:my-0">
              <dropdown-button ref="sortButton" v-if="currentClassBreaks.length > 1">
                <span slot="link" class="inline-flex items-center rounded-md border border-transparent px-2 py-1 text-sm font-medium leading-4 text-gray-700 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-1 w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 7.5L7.5 3m0 0L12 7.5M7.5 3v13.5m13.5 0L16.5 21m0 0L12 16.5m4.5 4.5V7.5" />
                </svg>
                  Sort Class
                </span>
                <div slot="dropdown" class="w-56 bg-white border shadow rounded-md overflow-hidden divide-y divide-gray-200 text-sm ">
                  <div class="py-1" role="none">
                    <a href="#" class="text-gray-900 group flex flex-col w-full px-2 py-2 text-gray-800 hover:bg-gray-200" @click="sortClass('ASC')">
                      <p class="text-base">Ascending</p>
                      <p class="text-sm">
                        <span v-if="currentClassSortField === 'date_of_birth'">
                          Order youngest to oldest
                        </span>
                        <span v-else>
                          Order lightest to heaviest
                        </span>
                      </p>
                    </a>
                    <a href="#" class="text-gray-900 group flex flex-col w-full px-2 py-2 text-gray-800 hover:bg-gray-200" @click="sortClass('DESC')">
                      <p class="text-base">Descending</p>
                      <p class="text-sm">
                        <span v-if="currentClassSortField === 'date_of_birth'">
                          Order oldest to youngest
                        </span>
                        <span v-else>
                          Order heaviest to lightest
                        </span>
                      </p>
                    </a>
                    <a href="#" class="text-gray-900 group flex flex-col w-full px-2 py-2 text-gray-800 hover:bg-gray-200" @click="sortClass('RANDOM')">
                      <p class="text-base">Random</p>
                      <p class='text-sm'>
                        Shuffle entries randomly
                      </p>
                    </a>
                  </div>
                  <div class="text-left p-2 text-xs">
                    <p class="">WARNING - Sorting entries will reset class breaks</p>
                  </div>
                </div>
              </dropdown-button>
            </div>
          </div>
        </div>
      </div>

      <div id="showbook-section" class="mx-0 sm:px-4 py-2" :class="{'border-4': testMode, 'border-blue-600': testMode, 'mr-1': testMode}">
        <div v-if="currentClassBreaks.filter(e => e.type !== 'break').length > 0" class="flex flex-col xl:flex-row w-full justify-between">
          <manual-class-break-single class="max-w-6xl w-full" ref="manualShowBreaks" :classObject="currentClassObject" :currentClassBreaks="currentClassBreaks" :arrangeEntries="arrangeEntries" :class_calc="class_calc" :show_book="show_book" :selectedClass="selectedClass" @reloadShowBook="getShowBook"/>
          <div class="hidden w-128">
            <h3 class="text-center text-xl mt-3">Entries Not Checked In</h3>
          </div>
        </div>
        <div v-else>
          <div class="text-center max-w-4xl mx-auto mt-8">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-12 h-12 mx-auto text-gray-600">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
            </svg>

            <h3 class="mt-2 text-xl font-medium text-gray-900">No entries in this class</h3>
            <p class="mt-1 text-base text-gray-600">There aren't any entries currently checked-in for this class.<br/><span class="font-bold">Reminder:</span> Entries must be checked-in and/or weighed-in before they are included in the show books.</p>
            <template v-if="!totalEntries">
              <div class="mt-12 flex justify-center space-x-4">
                <!--<button @click="$router.go('admin.check-in')" type="button" class="inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="-ml-1 mr-2 h-5 w-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75" />
                  </svg>

                  Go To Check-In
                </button>-->
                <a type="button" class="inline-flex items-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" :href="`/print?show_id=${show_book.show_id}&ring_id=${encodeURIComponent(selectedRing)}&type=${printShowType}&name=${encodeURIComponent(show_book.name)}&list_type=Ring List&preview=true&start_date=${adminData.event.start_date}&use_dynamic=${adminData.event.event_settings.dynamic_class_lists}&eventName=${encodeURIComponent(adminData.event.name)}`" target="_blank">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="-ml-1 mr-2 h-5 w-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Preview Show Book
                </a>
              </div>
              <p class='text-sm text-gray-700 mt-1'>Click here if you are looking to preview the show book prior to your show</p>
            </template>
            <template v-else>
              <p class="text-xl mt-5">Try changing the class or division to view the entries in this show.</p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <NoAccess :section="'Show Books'" :admin_email="adminData.show_admin.email"/>
  </div>
</template>

<script>
import ManualClassBreakSingle from '@/components/admin/ManualClassBreakSingle.vue'
import ConfigureShowRings from '@/components/admin/ConfigureShowRings.vue'
import UpdateShowOrder from '@/components/admin/updateShowOrder'
import Vue from 'vue'
import NoAccess from '@/views/admin/NoAccess.vue'

export default {
  components: {
    ManualClassBreakSingle,
    UpdateShowOrder,
    ConfigureShowRings,
    NoAccess
  },
  data () {
    return {
      preview_data: false,
      show_book: null,
      showBookLoading: false,
      class_calc: null,
      no_weight: null,
      show_book_published: false,
      arrangeEntries: false,
      // From Old Manual Class Break
      selectedClass: null,
      selectedDivision: {},
      selectedRing: null,
      // sub_divisions: [],
      // new_division: null,
      currentClassObject: {},
      testMode: false
    }
  },
  methods: {
    navClicked (where) {
      this.$refs['top'].scrollIntoView({
        behavior: 'smooth'
      })

      setTimeout(() => {
        let dropdown = this.$refs[`${where}_dropdown`]
        dropdown.activate()
      }, 300)
    },
    getShowBook () {
      this.showBookLoading = true
      this.selectedClass = null
      this.$store.dispatch('getShowBook', {
        show_id: this.show_book.show_id,
        ring_id: this.selectedRing,
        preview: this.preview_data,
        regen: false,
        breakable: true,
        results: false,
        start_date: this.adminData.event.start_date,
        use_dynamic: this.adminData.event.event_settings.dynamic_class_lists,
        testMode: this.testMode
      })
        .then(response => {
          this.showBookUpdateAfterGet(response)
        })
        .catch(() => {
          this.notie.alert({
            type: 3,
            text: `Error loading Show Book please refresh the browser and try again`
          })
          this.showBookLoading = false
        })
    },
    regenShowBook () {
      this.$refs.dropdownButton.close()
      this.notie.confirm({
        text: `<p class="mb-1 text-xl md:text-2xl font-bold">WARNING: All class breaks and sub divisions you have made will be lost.</p><p class=" text-xl md:text-2xl">Are you sure you want to regenerate this show book?</p>`,
        submitCallback: () => {
          this.showBookLoading = true
          this.$store.dispatch('getShowBook', {
            show_id: this.show_book.show_id,
            preview: this.preview_data,
            regen: true,
            breakable: true,
            results: false,
            start_date: this.adminData.event.start_date,
            use_dynamic: this.adminData.event.event_settings.dynamic_class_lists
          })
            .then(response => {
              this.selectedClass = null
              this.showBookUpdateAfterGet(response)
            })
            .catch(() => {
              this.notie.alert({
                type: 3,
                text: `Error loading Show Book please refresh the browser and try again`
              })
              this.showBookLoading = false
            })
        }
      })
    },
    ringConfigUpdated () {
      this.saveShowBook()
        .then(() => {
          this.getShowBook()
        })
    },
    showBookUpdateAfterGet (response) {
      this.class_calc = response.data.class_calc
      // Always turn on use_class_name
      /* this.class_calc.manual_use_class_name = true */

      Vue.set(this.show_book, 'class_list_id', response.data.class_list_id)
      this.no_weight = response.data.no_weight

      setTimeout(() => {
        Vue.set(this.show_book, 'show_book', response.data.show_book)
        this.show_book.show_book = this.filterRingDivisions(this.show_book.show_book, this.selectedRing, this.show_book.show_settings.ring_settings)

        this.showBookLoading = false
        if (!this.selectedRing && this.ring_list.length > 1) {
          this.selectedRing = this.ring_list[0]
        } else if (this.ring_list.length === 0) {
          this.selectedRing = null
        }
        // Check if Show Book is Published
        if (this.selectedRing && this.ring_list.length > 1) {
          if (this.show_book.show_settings.ring_settings) {
            let ringSettings = this.show_book.show_settings.ring_settings.find(r => r.name === this.selectedRing)
            if (ringSettings) {
              this.show_book_published = ringSettings.publish_show_book
            }
          }
        } else {
          this.show_book_published = response.data.show_book_published
        }
        this.selectNextAvailableDivision()
      }, 350)
    },
    showBookPublishedUpdate () {
      let payload = {}
      if (!this.selectedRing) {
        payload = {
          show_id: this.show_book.show_id,
          field: 'publish_show_book',
          value: this.show_book_published
        }
      } else {
        this.show_book.show_settings.ring_settings.forEach(r => {
          if (r.name === this.selectedRing) {
            r.publish_show_book = this.show_book_published
          }
        })
        payload = {
          show_id: this.show_book.show_id,
          field: 'ring_settings',
          value: this.show_book.show_settings.ring_settings
        }
      }
      this.$store.dispatch('updateShowSettings', payload)
        .then(() => {
          // console.log(response)
        })
        .catch(() => {
          // console.log('in catch')
          // console.log(error)
        })
    },
    updateEntryOrder () {
      // Add in flag to class #1 for using true_live
      // Only for shows with a start date after 9/9/22
      // Disable this for now because I will just do a merge instead.
      /* if (this.adminData.event.start_date > '2022-09-29') {
        this.show_book.show_book[0].use_true_live = true
      } */
      this.show_book.show_book.forEach(c => {
        if (c.entryType === 'standard') {
          let count = 0
          c.entry_breaks.forEach((e, i) => {
            if (e.type === 'break') {
              count = 0
            } else {
              e.saved_order = count
              count += 1
            }
          })
        }
      })
    },
    saveShowBook () {
      this.updateEntryOrder()
      return this.$store.dispatch('saveShowBookManual', {
        event_id: this.adminData.event.event_id,
        show_id: this.show_book.show_id,
        show_book: this.show_book.show_book, // this.$refs.manualShowBreaks.breakableShowBook,
        admin_id: this.adminData.event.admin_id,
        class_calc: this.class_calc,
        testMode: this.testMode
      })
        .then(() => {
          this.notie.alert({
            type: 1,
            text: `Show Book Saved`
          })
        })
    },
    /* addSubDivision () {
      if (this.new_division) {
        if (this.sub_divisions.indexOf(this.new_division === -1)) {
          this.sub_divisions.push(this.new_division)
        }
      }
      this.new_division = null
    },
    resetSubDivisions () {
      this.sub_divisions = []
      this.show_book.show_book.forEach(c => {
        if (c.entry_breaks) {
          c.entry_breaks.forEach(e => {
            if (this.sub_divisions.indexOf(e.sub_division) === -1 && e.sub_division && !c.hide && c.division === this.selectedDivision.name) {
              this.sub_divisions.push(e.sub_division)
            }
          })
        }
      })
    }, */
    updateSelectedDivision () {
      setTimeout(() => {
        this.setClass(this.class_list[0])
      }, 200)
    },
    setClass (c) {
      this.selectedClass = c
      this.getCurrentClassObject()
      // this.resetSubDivisions()
    },
    getCurrentClassObject () {
      this.show_book.show_book.forEach(c => {
        // if (c.entryType.toLowerCase() !== 'champion' && (c.division === this.selectedDivision.name || !this.class_calc.manual_use_class_name)) {
        if (c.entryType.toLowerCase() !== 'champion' && (c.division === this.selectedDivision.name)) {
          if (this.selectedClass === c.class_name) {
            this.currentClassObject = c
          }
        }
      })
    },
    getClassCount (name) {
      let count = 0
      if (this.showBookLoaded) {
        this.show_book.show_book.forEach(c => {
          // if (c.entryType.toLowerCase() !== 'champion' && (c.division === this.selectedDivision.name || !this.class_calc.manual_use_class_name)) {
          if (c.entryType.toLowerCase() !== 'champion' && (c.division === this.selectedDivision.name)) {
            if (name === c.class_name) {
              if (c.entries) {
                count = c.entries.length
              }
            }
          }
        })
      }
      return count
    },
    selectNextAvailableDivision () {
      if (this.showBookLoaded) {
        let set = false
        this.show_book.show_book.forEach(c => {
          if (c.division !== 'Overall' && !set && !c.hide) {
            this.selectedClass = c.class_name // this.class_calc.manual_use_class_name ? c.class_name : c.division
            this.selectedDivision = this.division_list[0]
            this.updateSelectedDivision()
            set = true
          }
        })
      }
    },
    divisionOrderUpdated (newClassOrder, divisionGroups) {
    // Add in a check for unsaved changes before updating.
    // IF there are saves do it before updating order..

      let divisionOrder = []
      divisionGroups.forEach(dg => {
        if (dg.division !== 'Overall') {
          divisionOrder.push(dg.division)
        }
      })

      // Save show_settings
      let payload = {
        show_id: this.show_book.show_id,
        field: 'division_order',
        value: divisionOrder
      }
      this.$store.dispatch('updateShowSettings', payload)
        .then(() => {
          this.getShowBook()
        })
        .catch(() => {
        })
    },
    saveClass (cl) {
      cl.name = 'class_lists'
      cl.class_list_id = cl.classID

      this.$store.dispatch('updateData', cl)
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Class Updated`
          })
        })
        .catch(() => {
          this.notie.alert({
            type: 3,
            text: `Error Updating class, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    sortClass (order) {
      let first = this.currentClassBreaks.shift()
      first.sub_division = ''
      // remove all breaks
      this.currentClassBreaks.forEach((cb, i) => {
        if (cb.type === 'break') {
          Vue.delete(this.currentClassBreaks, i)
        }
      })
      if (order === 'ASC') {
        if (this.currentClassSortField !== 'date_of_birth') {
          this.currentClassBreaks.sort((a, b) => a.entry_details[this.currentClassSortField] - b.entry_details[this.currentClassSortField])
        } else {
          this.currentClassBreaks.sort((a, b) => {
            let date1 = new Date(a.entry_details.date_of_birth)
            let date2 = new Date(b.entry_details.date_of_birth)
            if (date1 > date2) return -1
            if (date1 < date2) return 1
            return 0
          })
        }
      } else if (order === 'DESC') {
        if (this.currentClassSortField !== 'date_of_birth') {
          this.currentClassBreaks.sort((b, a) => a.entry_details[this.currentClassSortField] - b.entry_details[this.currentClassSortField])
        } else {
          this.currentClassBreaks.sort((b, a) => {
            let date1 = new Date(a.entry_details.date_of_birth)
            let date2 = new Date(b.entry_details.date_of_birth)
            if (date1 > date2) return -1
            if (date1 < date2) return 1
            return 0
          })
        }
      } else {
        this.currentClassBreaks.sort(() => 0.5 - Math.random())
      }
      this.currentClassBreaks.unshift(first)
      this.$refs.sortButton.close()
    },
    testModeChange () {
      this.testMode = !this.testMode
      this.getShowBook()
      this.$refs.dropdownButton.close()
    }
  },
  computed: {
    adminData () {
      return this.$store.state.admin.adminData
    },
    currentUser () {
      return this.$store.state.user
    },
    userHasAccess () {
      let access = false
      let foundUser = false
      if (this.adminData.admin_id === this.currentUser.user_id || this.currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2') {
        access = true
      } else {
        this.adminData.event_user_access.forEach(ur => {
          if (ur.user_id === this.currentUser.user_id) {
            foundUser = true
            access = ur.show_books_access
          }
        })
      }
      // If still no code set check if included in admin_id then assume it is a show series specialist and set to FULL for now.
      if (!foundUser) {
        if (this.adminData.admin_ids.includes(this.currentUser.user_id)) {
          access = true
        } else if (this.currentUser.role === 'ADMIN') {
          access = true
        }
      }
      return access
    },
    printShowType () {
      if (this.showBookLoaded) {
        let type = this.show_book.type.split('_')[0]
        if (type === 'CJLA') {
          type = 'MARKET'
        }
        return type
      }
      return ''
    },
    showBookLoaded () {
      if (this.show_book && !this.showBookLoading) {
        return true
      } else {
        return false
      }
    },
    ring_list () {
      let ringList = []
      if (this.showBookLoaded) {
        if (this.show_book.show_settings.ring_settings) {
          this.show_book.show_settings.ring_settings.forEach(r => {
            if (r.name !== 'Overall') {
              ringList.push(r.name)
            }
          })
        }
      }
      return ringList
    },
    divisions () {
      let div = new Set()
      if (this.showBookLoaded) {
        this.show_book.show_book.forEach(c => {
          if (c.entryType.toLowerCase() === 'standard' && !c.hide) {
            div.add(c.division)
          }
        })
      }
      return div
    },
    division_list () {
      let divList = []
      this.divisions.forEach(d => {
        let count = 0
        this.show_book.show_book.forEach(c => {
          if (c.division === d) {
            if (c.entries) {
              count += c.entries.length
            }
          }
        })
        divList.push({
          name: d,
          count: count
        })
      })
      return divList
    },
    class_list () {
      let l = []
      if (this.showBookLoaded) {
        this.show_book.show_book.forEach(c => {
          // if (c.entryType.toLowerCase() !== 'champion' && (c.division === this.selectedDivision.name || !this.class_calc.manual_use_class_name)) {
          if (c.entryType.toLowerCase() !== 'champion' && (c.division === this.selectedDivision.name)) {
            l.push(c.class_name)
          }
        })
      }
      return l
    },
    currentClassBreaks () {
      if (this.selectedClass) {
        let showBook = [...this.show_book.show_book]
        let breaks = showBook.filter((c, i) => {
          // if (this.class_calc.manual_use_class_name) {
          if (c.entryType.toLowerCase() !== 'champion' && c.class_name === this.selectedClass) {
            return true
          }
          /* } else {
            if (c.entryType.toLowerCase() !== 'champion' && c.division === this.selectedClass) {
              return true
            }
          } */
        })[0].entry_breaks

        let classCount = 1
        let entryCount = 0
        let lastBreakIndex = 0
        breaks.forEach((b, i) => {
          if (b.type === 'break') {
            b.name = `Break ${classCount}`
            classCount += 1
            breaks[lastBreakIndex].entry_count = entryCount
            lastBreakIndex = i
            entryCount = 0
          } else {
            entryCount += 1
          }
        })
        // Set last entry_count
        if (breaks.length > 0) {
          breaks[lastBreakIndex].entry_count = entryCount
        }

        return breaks
      } else {
        return []
      }
    },
    totalEntries () {
      return this.division_list.reduce((a, c) => a + c.count, 0)
    },
    currentClassSortField () {
      // Check if sub divisions and do a warning..
      let sortField = 'date_of_birth'
      if (this.class_calc.calculate_by === 'weight' || this.currentClassObject.break_type === 'weight') {
        sortField = 'weight'
      }
      return sortField
    }
  },
  mounted () {
    // this.selectNextAvailableDivision()
    // this.resetSubDivisions()
  }
}
</script>

<style>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.draggable:hover {
  cursor: grab;
}
</style>
